import React, { useLayoutEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';

import translations from 'lang';
import {
  defaultLang,
  filterByAvailableLocale,
  setIntl,
  storageKey,
  translationsKey,
} from './utilities';

export const LangContext = React.createContext({
  lang: '',
  switchLang: (langKey: string): void => {
    // pragma: no cover
  },
});

type Props = {
  children?: React.ReactChild | React.ReactChild[];
};

const Intl: React.FC<Props> = ({ children }) => {
  const [lang, setLang] = useState<translationsKey>(
    filterByAvailableLocale(
      localStorage.getItem(storageKey) || navigator.language || defaultLang,
    ),
  );

  const [messages, setMessages] = useState({});

  useLayoutEffect(() => {
    const selectedLang = localStorage.getItem(storageKey);
    if (selectedLang) setLang(filterByAvailableLocale(selectedLang));

    translations[lang].then(setMessages);
    setIntl(lang);
  }, [lang]);

  const switchLang = (langKey: string) => {
    const filteredLangKey = filterByAvailableLocale(langKey);
    setLang(filteredLangKey);
    localStorage.setItem(storageKey, filteredLangKey);
  };

  return (
    <LangContext.Provider value={{ lang, switchLang }}>
      <IntlProvider
        messages={messages}
        locale={lang}
        defaultLocale={defaultLang}
      >
        {children}
      </IntlProvider>
    </LangContext.Provider>
  );
};

export default Intl;
